"use client";

import useModal from "@/lib/hooks/useModal";

export default function useFilterModal() {
  const { isOpen, openModal, closeModal, toggleModal } = useModal(
    "filter-modal",
    () => {}
  );

  return {
    isOpen,
    openModal,
    closeModal,
    toggleModal,
  };
}
